import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-090e0768"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container blog-single-meta-container" }
const _hoisted_2 = { class: "blog-single-meta" }
const _hoisted_3 = { class: "blog-meta meta-all d-flex justify-content-between flex-wrap" }
const _hoisted_4 = { class: "meta-wrap meta-post-author" }
const _hoisted_5 = { href: "https://proxyscrape.com/blog/author/admin/" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "By: Proxyscrape", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_9 = { class: "meta-wrap meta-post-comments" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Comments Off ", -1))

import { BIconChatLeft, BIconPerson } from 'bootstrap-icons-vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createVNode(_unref(BIconPerson)),
            _hoisted_6,
            _hoisted_7
          ])
        ]),
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_unref(BIconChatLeft)),
          _hoisted_10,
          _hoisted_11
        ])
      ])
    ])
  ]))
}
}

})